import { render, staticRenderFns } from "./IconYpoConcierge.vue?vue&type=template&id=3d5534b0&"
import script from "./IconYpoConcierge.vue?vue&type=script&lang=js&"
export * from "./IconYpoConcierge.vue?vue&type=script&lang=js&"
import style0 from "./IconYpoConcierge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports